import { render } from "./rec.vue?vue&type=template&id=778be264&scoped=true"
import script from "./rec.vue?vue&type=script&lang=js"
export * from "./rec.vue?vue&type=script&lang=js"

import "./rec.vue?vue&type=style&index=0&id=778be264&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778be264"]])

export default __exports__